import React from 'react';
import {Col, Row} from "react-bootstrap";
import {formatDate} from '../../../../../../../utils/util';

const componentName = "dataBlock";

export default function DataBlock({ customClass, param1, param2, param3, param4, data, title, colNumber }) {

  return (
    <Col>
      <div className="bg-light rounded-3 p-3">
        <h5 id={`${componentName}-header`} className="fs-5 fw-bold">{title}</h5>
        <Row className={`row-cols-${colNumber} g-2`}>
          {data?.map((e, idx) =>
            <Col key={`dataBlock-${title}-${idx}`}>
              <div className={`${customClass} mb-2`}>
                {e?.[param1] && (
                  <label id={`${componentName}-labName-${idx}`} className="d-block">
                    {e?.[param1]}
                  </label>
                )}
                {e?.[param2] && (
                  <div id={`${componentName}-labResult-${idx}`}>
                    {e?.[param2]}
                  </div>
                )}
                {e?.[param3] && (
                  <small id={`${componentName}-orderingProvName-${idx}`} className="d-block text-secondary">
                    Ordered by: {e?.[param3]}
                  </small>
                )}
                {e?.[param4] && (
                  <small id={`${componentName}-labDate-${idx}`} className="d-block text-secondary">
                    {formatDate(e?.[param4])}
                  </small>
                )}
              </div>
            </Col>
          )}
        </Row>
      </div>
    </Col>
  )
}
